<div *ngIf="showIndustry && isLoaded">
  <hb-dynamic-auto-complete [control]="industryDropdownControl" [formGroup]="formGroup"></hb-dynamic-auto-complete>

  <hb-dynamic-auto-complete [control]="businessInputControl" [formGroup]="formGroup"></hb-dynamic-auto-complete>

  <hb-dynamic-auto-complete [control]="installationInputControl" [formGroup]="formGroup"></hb-dynamic-auto-complete>

  <hb-dynamic-auto-complete [control]="plantUnitInputControl" [formGroup]="formGroup"></hb-dynamic-auto-complete>

  <hb-dynamic-auto-complete-double [control]="systemSectionInputControl" [formGroup]="formGroup">
  </hb-dynamic-auto-complete-double>
</div>